<div class="tab-header {{ style }}">
  <button
    *ngFor="let tab of tabs; let i = index"
    class="tab-button {{ style }}"
    [class.active]="i === activeIndex"
    (click)="selectTab(i)"
    [disabled]="tab.disabled"
  >
    <span>
      {{ tab.label }}
    </span>
    <span *ngIf="tab.flagColor" class="flag {{ tab.flagColor }}"></span>
  </button>
</div>
